import { useSessionStore } from "@/stores/sessionStore";
import { login } from "@/lib/auth";
import { Button } from "@/components/ui/button";

export function SessionExpiredModal() {
  const expired = useSessionStore((s) => s.expired);

  if (!expired) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-(--background-overlay)">
      <div className="mx-4 w-full max-w-sm rounded-(--radius-lg) border border-(--border) bg-(--background-surface) p-6 shadow-(--shadow-xl)">
        <h2 className="text-lg font-semibold text-(--foreground)">
          Session expired
        </h2>
        <p className="mt-2 text-sm text-(--foreground-muted)">
          Your session has expired. Log in to continue.
        </p>
        <Button
          className="mt-4 w-full"
          onClick={() => login()}
        >
          Log in
        </Button>
      </div>
    </div>
  );
}
